import React, { useState, useContext, useEffect } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useNavigate, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import DatePicker from "react-datepicker";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "./UpdateObjectiveForm.css";

function UpdateObjectiveForm() {
  const [description, setDescription] = useState("");
  const [weight, setWeight] = useState(0);
  const [dueDate, setDueDate] = useState(new Date());
  const [bossObjective, setBossObjective] = useState("");
  const [bossObjectives, setBossObjectives] = useState([]);
  const [availableWeight, setAvailableWeight] = useState(100);
  const [isLoading, setIsLoading] = useState(true);
  const [show, setShow] = useState(false);

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const { oid } = useParams();

  const { t } = useTranslation();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/objectives/user/update/${oid}`,
        data: {
          status: "active",
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setAvailableWeight(response.data.availableWeight);
      setBossObjectives(response.data.bossObjectives);
      setDescription(response.data.objective.description);
      setWeight(response.data.objective.weight);
      setDueDate(new Date(response.data.objective.dueDate));
      setBossObjective(response.data.objective.bossObjective);

      setIsLoading(false);
    }
    fetch();
  }, [state.token, state.userId, oid]);

  const handleSubmit = async () => {
    try {
      if (validateWeight(weight)) {
        await axios({
          method: "put",
          url: `${process.env.REACT_APP_BACKEND_URL}/objectives/${oid}`,
          data: {
            description: description,
            weight: weight,
            dueDate: dueDate,
            bossObjective: bossObjective,
          },
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
        });
        navigate("/myobjectives");
      } else {
        handleShow();
      }
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const validateWeight = (weight) => {
    if (weight > availableWeight) {
      return false;
    } else {
      return true;
    }
  };

  const handleDescriptionChange = (evt) => {
    setDescription(evt.target.value);
  };

  const handleWeightChange = (evt) => {
    setWeight(evt.target.value);
  };

  const handleBossObjectiveChange = (evt) => {
    setBossObjective(evt.target.value);
  };

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Col className="new-objective-header">
            <h2>{t("Objetivos.Objetivo.EditForm.Titulo")}</h2>
          </Col>
        </Row>
        <Row>
          <Col className="new-objective-form">
            <Col className="availble-weight">
              <h5>
                {t("Objetivos.Objetivo.EditForm.PonderacionDisponible")}{" "}
                {availableWeight}
              </h5>
            </Col>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>
                  {t("Objetivos.Objetivo.EditForm.ObjetivoJefeDirecto")}
                </Form.Label>
                <Form.Select
                  onChange={handleBossObjectiveChange}
                  value={bossObjective}
                >
                  <option value="">
                    {t("Objetivos.Objetivo.EditForm.SeleccionarObjetivo")}
                  </option>
                  {bossObjectives.map((objective) => (
                    <option key={objective._id} value={objective._id}>
                      {objective.description}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>
                  {t("Objetivos.Objetivo.EditForm.Descripcion")}
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder={t(
                    "Objetivos.Objetivo.EditForm.IngresaDescripcion",
                  )}
                  onChange={handleDescriptionChange}
                  value={description}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>
                  {t("Objetivos.Objetivo.EditForm.Ponderacion")}
                </Form.Label>
                <Row className="justify-content-center align-items-center">
                  <Col lg={11}>
                    <Form.Range
                      defaultValue={weight}
                      name="weight"
                      onChange={(e) => handleWeightChange(e)}
                    />
                  </Col>
                  <Col lg={1}>
                    <span className="weightVal">{weight}</span>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>
                  {t("Objetivos.Objetivo.EditForm.FechaMeta")}
                </Form.Label>
                <DatePicker
                  selected={dueDate}
                  name="dueDate"
                  onChange={(date) => setDueDate(date)}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Button className="primary" onClick={handleSubmit}>
                  {t("Objetivos.Objetivo.EditForm.Guardar")}
                </Button>
                <Link to="/objectives">
                  <Button className="danger">
                    {t("Objetivos.Objetivo.EditForm.Cancelar")}
                  </Button>
                </Link>
              </Form.Group>
            </Form>
          </Col>
        </Row>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {t("Objetivos.Objetivo.EditForm.PonderacionExcedida")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {t("Objetivos.Objetivo.EditForm.PonderacionExcede")}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t("Objetivos.Objetivo.EditForm.Cerrar")}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}

export default UpdateObjectiveForm;
